
import React from "react";

export default function Home ({ className, color })  {
  return (
    <svg
      className={`${className}`}
      fill="none"
      height="24"
      viewBox="0 0 24 24"
      width="24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M19.978 7.31539L14.978 3.29398C13.252 1.9065 10.748 1.9065 9.022 3.29398L4.022 7.31539C2.896 8.22071 2.25 9.56816 2.25 11.0127V17.0067C2.25 19.6236 4.381 21.7534 7 21.7534H9.75V17.0067C9.75 15.7683 10.759 14.76 12 14.76C13.241 14.76 14.25 15.7683 14.25 17.0067V21.7534H17C19.619 21.7534 21.75 19.6246 21.75 17.0067V11.0127C21.75 9.56816 21.104 8.22071 19.978 7.31539ZM20.25 17.0067C20.25 18.7964 18.792 20.2529 17 20.2529H15.75V17.0067C15.75 14.941 14.068 13.2594 12 13.2594C9.932 13.2594 8.25 14.941 8.25 17.0067V20.2529H7C5.208 20.2529 3.75 18.7964 3.75 17.0067V11.0127C3.75 10.0253 4.191 9.10402 4.961 8.4848L9.961 4.46339C11.143 3.51407 12.857 3.51407 14.038 4.46339L19.038 8.4848C19.808 9.10402 20.249 10.0253 20.249 11.0127V17.0067H20.25Z"
        fill={color ||"#6F6C99"}
      />
    </svg>
  );
};